import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { Input } from 'antd';
import type { TextAreaProps } from 'antd/es/input';

import css from './style.module.less';

export interface SimpleTextAreaProps extends TextAreaProps {

}

export const SimpleTextArea = forwardRef<any, SimpleTextAreaProps>((props, ref: any) => {
  return <Input.TextArea {...props} className={classNames(props.className, css.simpleInput)} ref={ref} />;
});